import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../images/image2.png'
import _imports_1 from '../images/image7.png'
import _imports_2 from '../images/image.png'
import _imports_3 from '../images/image6.png'
import _imports_4 from '../images/image3.png'
import _imports_5 from '../images/token-img.png'
import _imports_6 from '../images/image5.png'
import _imports_7 from '../images/image4.png'
import _imports_8 from '../images/image-remote.png'


const _withScopeId = (n: any) => (_pushScopeId("data-v-be22e1e6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tutorial-container" }
const _hoisted_2 = { class: "tutorial-content el-card" }
const _hoisted_3 = {
  id: "section1",
  class: "section"
}
const _hoisted_4 = { class: "section-title" }
const _hoisted_5 = { class: "section-content" }
const _hoisted_6 = {
  id: "section2",
  class: "section"
}
const _hoisted_7 = { class: "section-title" }
const _hoisted_8 = { class: "section-content" }
const _hoisted_9 = {
  id: "section2-1",
  class: "section"
}
const _hoisted_10 = { class: "sub-title" }
const _hoisted_11 = { class: "step-item" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_13 = { class: "step-item" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  style: {"object-fit":"contain","width":"100%","height":"100%"},
  alt: ""
}, null, -1))
const _hoisted_15 = {
  id: "section2-2",
  class: "section"
}
const _hoisted_16 = { class: "sub-title" }
const _hoisted_17 = { class: "step-item" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
}, null, -1))
const _hoisted_19 = { class: "step-item" }
const _hoisted_20 = { class: "warning-text" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: "",
  style: {"margin":"auto"}
}, null, -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  style: {"object-fit":"contain","width":"100%","height":"100%"},
  alt: ""
}, null, -1))
const _hoisted_23 = { class: "step-item" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  alt: ""
}, null, -1))
const _hoisted_25 = { class: "step-item" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "image-box phone-demo-container" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_6,
    style: {"object-fit":"contain","width":"500px","height":"100%"},
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_7,
    style: {"object-fit":"contain","width":"500px","height":"100%"},
    alt: ""
  })
], -1))
const _hoisted_27 = { class: "step-item" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_8,
  style: {"object-fit":"contain","width":"100%","height":"100%"},
  alt: ""
}, null, -1))

import { useI18n } from 'vue-i18n'


export default /*#__PURE__*/_defineComponent({
  __name: 'word-remote',
  setup(__props) {

const { t } = useI18n()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("section", _hoisted_3, [
        _createElementVNode("h2", _hoisted_4, _toDisplayString(_unref(t)('remoteAuth.wordRemote.section1Title')), 1),
        _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(t)('remoteAuth.wordRemote.section1Content')), 1)
      ]),
      _createElementVNode("section", _hoisted_6, [
        _createElementVNode("h2", _hoisted_7, _toDisplayString(_unref(t)('remoteAuth.wordRemote.section2Title')), 1),
        _createElementVNode("p", _hoisted_8, _toDisplayString(_unref(t)('remoteAuth.wordRemote.section2Intro')), 1)
      ]),
      _createElementVNode("section", _hoisted_9, [
        _createElementVNode("h3", _hoisted_10, _toDisplayString(_unref(t)('remoteAuth.wordRemote.passwordStepsTitle')), 1),
        _createElementVNode("p", _hoisted_11, _toDisplayString(_unref(t)('remoteAuth.wordRemote.passwordStep1')), 1),
        _hoisted_12,
        _createElementVNode("p", _hoisted_13, _toDisplayString(_unref(t)('remoteAuth.wordRemote.passwordStep2')), 1),
        _hoisted_14
      ]),
      _createElementVNode("section", _hoisted_15, [
        _createElementVNode("h3", _hoisted_16, _toDisplayString(_unref(t)('remoteAuth.wordRemote.tokenStepsTitle')), 1),
        _createElementVNode("p", _hoisted_17, _toDisplayString(_unref(t)('remoteAuth.wordRemote.tokenStep1')), 1),
        _hoisted_18,
        _createElementVNode("p", _hoisted_19, _toDisplayString(_unref(t)('remoteAuth.wordRemote.tokenStep2')), 1),
        _createElementVNode("p", _hoisted_20, _toDisplayString(_unref(t)('remoteAuth.wordRemote.tokenWarning')), 1),
        _hoisted_21,
        _hoisted_22,
        _createElementVNode("p", _hoisted_23, _toDisplayString(_unref(t)('remoteAuth.wordRemote.tokenStep3')), 1),
        _hoisted_24,
        _createElementVNode("p", _hoisted_25, _toDisplayString(_unref(t)('remoteAuth.wordRemote.tokenStep4')), 1),
        _hoisted_26,
        _createElementVNode("p", _hoisted_27, _toDisplayString(_unref(t)('remoteAuth.wordRemote.tokenStep5')), 1),
        _hoisted_28
      ])
    ])
  ]))
}
}

})